/**
 * CfssDocumentsPage — CFSS Document Management
 *
 * Reuses the generic DocumentManager component.
 * Required documents: W-4, I-9, background check, service agreement.
 *
 * Route: /cfss/documents
 */

import React from 'react';
import { DocumentManager } from '@/components/documents';

export function CfssDocumentsPage() {
  return <DocumentManager />;
}

export default CfssDocumentsPage;
